import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter65.json";
import Head from "next/head";
export default function Chapter_65() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Iamblichus taught the soul’s embodiment as sacred, uniting spirit and matter in divine cosmic harmony."
        ></meta>
        <meta
          property="og:title"
          content="Iamblichus and the Sacred Unity of Soul and Cosmos"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Iamblichus saw the soul’s embodiment not as a fall but as sacred union with the Cosmos. Rejecting dualistic views, he affirmed the material world as a divine manifestation, essential to spiritual growth. His theurgy unites temporal experience with eternal being, echoing principles in Platonic thought, Advaita Vedanta, and modern physics, revealing the Cosmos as an active expression of the divine."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=65"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=65"
        ></meta>
        <meta
          name="twitter:title"
          content="Iamblichus and the Sacred Unity of Soul and Cosmos"
        ></meta>
        <meta
          name="twitter:description"
          content="For Iamblichus, the soul fully incarnates within the Cosmos, embodying both temporal life and infinite being. Unlike dualistic philosophies, he saw matter as sacred, not fallen. His theurgy celebrates the material world as divine expression, harmonizing Platonic metaphysics, Advaita Vedanta’s Shakti, and modern physics into a vision where spirit and matter are inseparable aspects of ultimate reality."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=65" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
